<template>
  <div id="wallpapers">
    <span class="title">defaultwallpapers</span>
    <form>
      <div id="opciones" class="flex-container">
        <div id="color-000" class="wallpaper flex-item" @click="changeBackground('color-000')">
          <div class="sound-type"> black</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-000" name="fondos">
            <label for="radio1"></label>
          </div>
        </div>

        <div id="color-333" class="wallpaper flex-item" @click="changeBackground('color-333')">
          <div class="sound-type"> darkgrey</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-333" name="fondos">
            <label for="radio2"></label>
          </div>
        </div>

        <div id="color-555" class="wallpaper flex-item" @click="changeBackground('color-555')">
          <div class="sound-type"> grey</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-555" name="fondos">
            <label for="radio3"></label>
          </div>
        </div>

        <div id="morningforest" class="wallpaper flex-item" @click="changeBackground('morningforest')">
          <div class="sound-type"> morningforest</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-morningforest" name="fondos">
            <label for="radio4"></label>
          </div>
        </div>

        <div id="spring-forest" class="wallpaper flex-item" @click="changeBackground('spring-forest')">
          <div class="sound-type"> springforest</div>
          <div class="roundedOne">
            <input type="radio" value="None" id="radio-spring-forest" name="fondos">
            <label for="radio5"></label>
          </div>
        </div>

        <div id="japan-garden" class="wallpaper flex-item" @click="changeBackground('japan-garden')">
          <div class="sound-type"> japangarden</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-japan-garden" name="fondos">
            <label for="radio6"></label>
          </div>
        </div>

        <div id="seashore-01" class="wallpaper flex-item" @click="changeBackground('seashore-01')">
          <div class="sound-type"> seashore</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-seashore-01" name="fondos">
            <label for="radio7"></label>
          </div>
        </div>

        <div id="cabo-de-palos" class="wallpaper flex-item" @click="changeBackground('cabo-de-palos')">
          <div class="sound-type">Cabo de Palos</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-cabo-de-palos" name="fondos">
            <label for="radio8"></label>
          </div>
        </div>

        <div id="deep-sea-ocean" class="wallpaper flex-item" @click="changeBackground('deep-sea-ocean')">
          <div class="sound-type"> deepocean</div>
          <div class="roundedOne">
            <input type="radio" value id="radio-deep-sea-ocean" name="fondos">
            <label for="radio9"></label>
          </div>
        </div>

        <div id="calmed-river" class="wallpaper flex-item" @click="changeBackground('calmed-river')">
          <div class="sound-type"> calmedriver</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-calmed-river" class="radio">
            <label for="radio10"></label>
          </div>
        </div>

        <div id="waterfall" class="wallpaper flex-item" @click="changeBackground('waterfall')">
          <div class="sound-type"> waterfall</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-waterfall" class="radio">
            <label for="radio11"></label>
          </div>
        </div>

        <div id="autumn-river" class="wallpaper flex-item" @click="changeBackground('autumn-river')">
          <div class="sound-type"> autumninriver</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-autumn-river" class="radio">
            <label for="radio12"></label>
          </div>
        </div>

        <div id="lake" class="wallpaper flex-item" @click="changeBackground('lake')">
          <div class="sound-type"> lake</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-lake" class="radio">
            <label for="radio13"></label>
          </div>
        </div>

        <div id="nebula-helix" class="wallpaper flex-item" @click="changeBackground('nebula-helix')">
          <div class="sound-type"> nebula: Helix</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-nebula-helix" class="radio">
            <label for="radio14"></label>
          </div>
        </div>

        <div id="starry-night" class="wallpaper flex-item" @click="changeBackground('starry-night')">
          <div class="sound-type"> starrynight</div>
          <div class="roundedOne">
            <input type="radio" name="fondos" id="radio-starry-night" class="radio">
            <label for="radio15"></label>
          </div>
        </div>

        <!-- Videos -->
        <div id="video-beach" class="wallpaper flex-item" @click="changeBackground('video-beach')">
          <div id="contenidoder" class="sound-type"> beach</div>
          <div class="videoRoundedOne">
            <input type="radio" name="fondos" id="radio-video-beach" class="radio">
            <label for="radio16"></label>
          </div>
          <video autoplay loop preload="auto" width="250" height="141">
            <source src="/src/assets/video/small/beach.mp4" type="video/ogg">
          </video>
        </div>

        <div id="video-cataract" class="wallpaper flex-item" @click="changeBackground('video-cataract')">
          <div id="contenidoder" class="sound-type"> cataract</div>
          <div class="videoRoundedOne">
            <input type="radio" name="fondos" id="radio-video-cataract" class="radio">
            <label for="radio17"></label>
          </div>
          <video autoplay loop preload="auto" width="250" height="141">
            <source src="/src/assets/video/small/cataract.mp4" type="video/ogg">
          </video>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                pantalla: ''
            }
        },
        mounted() {

        },
        methods: {
            changeBackground(background) {
                this.pantalla = background;  //$( background ).attr("id");
                
                /*/if (pantalla === 'color-000' || pantalla === 'color-333' || pantalla === 'color-555') {*/
                if (this.pantalla.substr(0, 5) === 'color') {
                    let color = this.pantalla.split("-");
                    $( ".fondo" ).css({'background': 'url("")', 'background-color': '#'+color[1]});
                    $( "#radio-"+color[1] ).prop("checked", true);
                    $( "#video_background" ).attr('src', '');
                } else if (this.pantalla.substr(0, 5) === 'video') {
                    /*/alert(pantalla.substr(6));*/
                    console.log(this.pantalla);
                    $( "#radio-video-"+this.pantalla.substr(6) ).prop("checked", true);
                    $( "#video_background" ).attr('src', '/src/assets/video/big/'+this.pantalla.substr(6)+'.mp4');
                }  else {
                    $( "#radio-"+this.pantalla ).prop("checked", true);
                    $( ".fondo" ).css({'background': 'url(/src/assets/img/jpg/' + this.pantalla + '.jpg) no-repeat fixed center', 'background-color': 'black',
                        '-webkit-background-size': 'cover', '-moz-background-size': 'cover', '-o-background-size': 'cover', 'background-size': 'cover'});
                    $( "#video_background" ).attr('src', '');
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Backgrounds.vue